import { BlockUI, AlertMessage, DialogMessage } from '../../Utility.jsx';
import React, { useState, useMemo, useEffect, useRef } from 'react';
import { UserModel } from '../../../models/UserModel.tsx';
import { useReadMutation, useCreateMutation, useUpdateMutation, useDeleteMutation  } from '../../../hooks/APIRequestHook.tsx';
import { BaseRequestAPIModel, RequestMstUserComponentModel, RequestAPIUrlModel } from '../../../models/BaseRequestModel.tsx';
import { BaseResponseModel } from '../../../models/BaseResponseModel.tsx';
import { BaseResponseAPIModel } from '../../../models/BaseResponseModel.tsx';
import { MST_USER_READ_URL, MST_USER_CREATE_URL, MST_USER_UPDATE_URL, MST_USER_DELETE_URL, GET_GBP_LIST_URL, GET_GBP_USER_MAPPING_LOCATION_LIST_URL, MST_USER_LOCATION_MAPPING_URL } from  '../../../const/APIUrl.js';
import { queryListUserCacheKey as cacheKey } from  '../../../const/QueryCacheKey.js';
import { formDataToPayload } from '../../../common/Object.tsx';
import { fetchAPI } from '../../../api/GenericFetch.js';
import { fetchPostAPI } from '../../../api/GenericFetch.js';
import {
  MaterialReactTable,
  type MRT_ColumnDef,
  type MRT_Row,
  useMaterialReactTable,
} from 'material-react-table';

import Dialog from '@mui/material/Dialog';

import {
  ListItemText,
  TextField,
  InputLabel,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormLabel,
  TextareaAutosize,
  FormControl,
  Select,
  MenuItem,
  Box,
  Tooltip,
  IconButton,   
  FormGroup,
} from '@mui/material';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MapIcon from '@mui/icons-material/Map';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import { SUCCESSFULLY_SAVE, SUCCESSFULLY_DELETE } from  '../../../const/Message.js';
import { setDelay } from  '../../../helpers/UI.js';

const DataTable = (request) => {
  const { data : dataTable, isFetchReadLoading } = useReadMutation<UserModel>({url : MST_USER_READ_URL, cacheKey, enableRefetch : request.enableRefetch});
  const { mutateAsync: deleteUser, isPending: isDeletingUser } = useDeleteMutation<UserModel>({cacheKey});
  const [ showDialog, setShowDialog] = useState(false);
  const [ dialogSetting, setDialogSetting ]  = useState({showCloseButton : false, messages : [SUCCESSFULLY_SAVE]});
  const [ showUserLocationMapping, setShowUserLocationMapping] = useState(false);
  const [ selectedRow, setSelectedRow] = useState({});

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const handleDeleteUser = async (Id: number) => {      
      const request = new BaseRequestAPIModel<UserModel>({ Id } as UserModel, {} as any, { url: MST_USER_DELETE_URL } as RequestAPIUrlModel);
      let apiResponse = await deleteUser(request);
      if (apiResponse.isSuccess !== undefined)
      {
            setShowDialog(true);
            if (!apiResponse.isSuccess) 
            {
                setDialogSetting({...dialogSetting, showCloseButton : true, messages : apiResponse.errorMessages });
            }
            else  {                                
                setDialogSetting({...dialogSetting, showCloseButton : false, messages : [SUCCESSFULLY_DELETE] });
                setDelay().then(() => {
                  setShowDialog(false);
                });
            }          
      }
  };

  //DELETE action
  const openDeleteConfirmModal = (row: MRT_Row<UserModel>) => {
    if (window.confirm('Are you sure you want to proceed?')) {
      handleDeleteUser(row.original.Id);
    }
  };  

  const columns = useMemo<MRT_ColumnDef<UserModel>[]>(
    () => [
        { accessorKey: 'Id', header: 'Id', visibleInShowHideMenu: false },
        { accessorKey: 'RoleId', header: 'RoleId', visibleInShowHideMenu: false },
        { accessorKey: 'Password', header: 'Password', visibleInShowHideMenu: false },
        { accessorKey: 'UserName', header: 'UserName' },
        { accessorKey: 'Email', header: 'Email', accessorFn: (row) => row.Email ?? '' },
        { accessorKey: 'FirstName', header: 'First Name', accessorFn: (row) => row.FirstName ?? ''},
        { accessorKey: 'LastName', header: 'Last Name', accessorFn: (row) => row.LastName ?? ''},
        { accessorKey: 'Gender', header: 'Gender', accessorFn: (row) => row.Gender ?? '', 
          editSelectOptions: 
          [
              { label: 'Male', value: 'M' },
              { label: 'Female', value: 'F' },
          ],  
          muiEditTextFieldProps: {
            select: true,
        },},
        { accessorKey: 'DOB', header: 'DOB', accessorFn: (row) => row.DOB ?? '' },
        { accessorKey: 'IsActive', header: 'Is Active', dataType:'boolean', 
          accessorFn: (row) => row.IsActive ? 'Yes' : 'No',
          muiTableHeadCellProps: 
          {
            align: 'center',
          },
          muiTableBodyCellProps: 
          {
            align: 'center', 
          },
        },
        { accessorKey: 'Notes', header: 'Notes', accessorFn: (row) => row.Notes?.substring(0, 30) ?? '' },
    ],
    [],
  );

  const table = useMaterialReactTable({
    columns,
    data: dataTable,
    enableRowActions: true, 
    createDisplayMode: 'modal',
    editDisplayMode:  'modal',
    enableEditing: true,
    state: {
      isLoading: isFetchReadLoading,
      showProgressBars: isFetchReadLoading,
    },
    initialState: {     
      showGlobalFilter: true,
       columnVisibility: {
          Id: false, 
          RoleId:false,
          Password:false,
      },
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <Box>
        {request.pageFunction.create &&
          <Button
            startIcon={<AddCircleIcon />}
            variant="contained"
            onClick={() => {
              table.setCreatingRow(true);
            }}
          >
            Add
          </Button>
        }
      </Box>
    ),
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: 'flex', gap: '1rem' }}>
        {request.pageFunction.update &&          
            <Tooltip title="Edit">
              <IconButton onClick={() => table.setEditingRow(row)}>
                <EditIcon />
              </IconButton>
            </Tooltip>
        }
        {request.pageFunction.delete &&
              <Tooltip title="Delete">
                <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
        }
        {request.pageFunction.userLocationMapping &&
            <Tooltip title="User Location Mapping">
                <IconButton color="success" onClick={() => 
                    { 
                      setSelectedRow(row);
                      setShowUserLocationMapping(true);                      
                    }}>
                  <MapIcon />
                </IconButton>
            </Tooltip>
        }
      </Box>
    ),
    renderEditRowDialogContent: ({ row, table }) => (     
        <DialogContentModal row={row} table={table} roleList={request.roleList} title={"Edit"} />
    ),
    renderCreateRowDialogContent: ({ row, table }) => (
        <DialogContentModal row={row} table={table} roleList={request.roleList} title={"New"} /> 
    ),
  });

  return(
    <>
      { isDeletingUser && <BlockUI /> }
      { showUserLocationMapping && <DialogUserLocationMapping title={"User Location Mapping"} row={selectedRow} buList={request.buList} gbpList={request.gbpList} setShowUserLocationMapping={setShowUserLocationMapping} /> }
      { showDialog && <DialogMessage dialogSetting={dialogSetting} onClose={handleCloseDialog}/>}
      <MaterialReactTable table={table} />
    </>
  );
};

const DialogUserLocationMapping = ({row, title, setShowUserLocationMapping, buList, gbpList }) => {
  let defaultBUValue = buList[0].value;
  const [ apiResponse, setApiResponse ] = useState({} as BaseResponseAPIModel<UserModel>);
  const [ isSaving, setIsSaving ] = useState();
  const [ gbpValue, setGBPValue ] = useState([] as any);
  const [ gbpListOption, setGBPListOption ] = useState(gbpList);
  const [ fetchSubmitResponseMessages , setFetchSubmitResponseMessages ] = useState(new BaseResponseModel());

  useEffect(() => {
    fetchAndSetGBPList(defaultBUValue);
    fetchAndSetUserMappingLocationList({userId : row.original.Id, bu : defaultBUValue});
  }, []);

  const handleBUChange = async (e) => {
    let id = e.target.value;    
    await Promise.all([
        fetchAndSetGBPList(id),
        fetchAndSetUserMappingLocationList({userId : row.original.Id, bu : id})
    ]);   
  };

  const fetchAndSetGBPList = async(id) => {
      const response = await fetchAPI({url : GET_GBP_LIST_URL + '?locationid=' + id, body: null});      
      setGBPListOption(response);      
  }

  const fetchAndSetUserMappingLocationList = async({userId, bu}) => {
      const response = await fetchAPI({url : GET_GBP_USER_MAPPING_LOCATION_LIST_URL + '?id=' + userId + '&LocationId=' + bu, body: null});      
      let selectedGBP = response.map(d => d.value);      
      setGBPValue(selectedGBP);      
  }  

  const handleGBPChange = (event) => {
      let value = event.target.value;      
      if (value.includes('-1')) {
          const allOptionValues = gbpListOption.map(d => d.value);
          setGBPValue(allOptionValues);
          return;
      }

      let newSelectedValues = (typeof value === 'string' ? value.split(',') : value);
      setGBPValue(prevValue => { return newSelectedValues; } );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputData = Object.fromEntries(formData.entries());

    const body = {
      UserId : row.original.Id,
      LocationId : inputData.BU,
      WarehouseIdList : inputData.GBP.toString().split(',')
    };

    const response = await fetchPostAPI({url : MST_USER_LOCATION_MAPPING_URL, body, includeBundleResponse: true});
    let responseData = await response.json();

    if (!response.ok || !responseData.isSuccess)
    {
        setFetchSubmitResponseMessages(prevValue => {
            let newValue = { ...prevValue };
            newValue.variant = 'danger';
            newValue.messages = responseData.errorMessages;
            return newValue;
        });

        // setDelay().then(() => {
        //     setFetchSubmitResponseMessages(new BaseResponseModel());
        // });
    }
    
    if (response.ok && responseData.isSuccess)
    {
          setFetchSubmitResponseMessages(prevValue => {
            let newValue = { ...prevValue };
            newValue.isSuccess = true;
            newValue.variant = 'success';
            newValue.messages = [SUCCESSFULLY_SAVE];
            return newValue;
        });
        setDelay().then(() => {
            setFetchSubmitResponseMessages(new BaseResponseModel());
        });
    }
    
  };

  return (
      <Dialog open={true} className="dialog-overflow-hidden p-1 mui-dialog-custom">
        {fetchSubmitResponseMessages.isSuccess && <DialogMessage />}
        <form onSubmit={handleFormSubmit} className="row p-3">
            <h1 className="h1">{title}</h1>
            {!fetchSubmitResponseMessages.isSuccess && <AlertMessage type={"error"} messages={fetchSubmitResponseMessages.messages} />}
            <TextField name="Id" label="Id" variant="standard" defaultValue={row.original.Id} sx={{ display: { xs: 'none', md: 'none' }}}/>
            <div className="form-group mb-3">
              <TextField name="UserName" className="col-md-12 col-12" label="UserName" variant="standard" defaultValue={row.original.UserName} slotProps={{ htmlInput: {readOnly: row.original.Id !== '' }}}/>
            </div>
            <FormGroup row className="mb-3">              
              <FormControl className="w-50 pe-3">
                <InputLabel id="bu-select-label">BU</InputLabel>
                {buList &&                               
                <Select name="BU" defaultValue={defaultBUValue} autoWidth={true} onChange={handleBUChange}>
                  {
                    buList.map((d) => (
                    <MenuItem key={d.Id} value={d.value}>{d.text}</MenuItem>
                    ))
                  }
                </Select>
              }
              </FormControl>
              <FormControl className="w-50 mb-3">
                <InputLabel id="gbp-select-label">GBP</InputLabel>
                {gbpListOption && 
                  <Select name="GBP" value={gbpValue} multiple autoWidth={true} onChange={handleGBPChange} 
                      renderValue={(selected) => {  
                        let selectedText = gbpListOption.filter(d => selected.includes(d.value)).map(d => d.text); 
                        return selectedText.join(','); 
                      }}
                    >
                    <MenuItem value="-1">Select All</MenuItem>
                    {
                      gbpListOption.map((d) => (                          
                        <MenuItem key={d.value} value={d.value}>
                          <Checkbox checked={gbpValue.includes(d.value)} />
                          <ListItemText primary={d.text} />
                        </MenuItem>
                      ))
                    }
                  </Select>                
                }                
              </FormControl>
            </FormGroup>
            <div className="form-group text-end">
              <Button className="col-lg-2 col-md-12 col-12" onClick={() => setShowUserLocationMapping(false)}>Cancel</Button>
              <Button className="col-lg-2 col-md-12 col-12" type="submit" variant="contained" disabled={isSaving}>Save</Button>
            </div>
        </form>
      </Dialog>
  );
}

const DialogContentModal = ({ title, row, table, roleList }) => {
  const [apiResponse, setApiResponse] = useState({} as BaseResponseAPIModel<UserModel>);
  const [showDialog, setShowDialog] = useState(false);

  const { mutateAsync: createUser, isPending: isCreatingUser } = useCreateMutation<UserModel>({cacheKey});
  const { mutateAsync: updateUser, isPending: isUpdatingUser } = useUpdateMutation<UserModel>({cacheKey});

  //Create action
  const handleCreateUser = async (data: UserModel) => { 
      const request = new BaseRequestAPIModel<UserModel>(data, {} as any, { url: MST_USER_CREATE_URL, additionalUrl : MST_USER_READ_URL } as RequestAPIUrlModel);
      console.log(request);
      let response = await createUser(request);  
      setApiResponse(response);
      if (response.isSuccess) {
          setShowDialog(!showDialog);
          setDelay().then(() => {    
              table.setCreatingRow(null);
          });
      }
  };

  //Update action
  const handleUpdateUser = async (data: UserModel, updatedRow : UserModel) => {
    const request = new BaseRequestAPIModel<UserModel>(data, updatedRow, { url: MST_USER_UPDATE_URL } as RequestAPIUrlModel);
    let response = await updateUser(request);
    setApiResponse(response);    
    if (response.isSuccess) {
        setShowDialog(!showDialog);
        setDelay().then(() => {    
            table.setEditingRow(null);
        });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const inputData = Object.fromEntries(formData.entries());

    let requestData = (formDataToPayload(inputData, row, table) as unknown) as any;

    if (requestData.payload.Id !== undefined && requestData.payload.Id > 0)
    {
      handleUpdateUser(requestData.payload, requestData.updatedRow);
    }
    else
    {
      handleCreateUser(requestData.payload);
    }
  };  

  return(
    <>
    <Dialog open={true} className="dialog-overflow-hidden p-1 mui-dialog-custom">
      {(isCreatingUser || isUpdatingUser) && <BlockUI />}
      {showDialog && <DialogMessage />}
        <form onSubmit={handleFormSubmit} className="p-3 overflow-y-auto">
            <h1 className="h1">{title}</h1>
            <div className="form-group mb-3">
              {<AlertMessage type={"error"} messages={apiResponse.errorMessages} />}
            </div>
            <TextField name="Id" label="Id" variant="standard" defaultValue={row.original.Id} sx={{ display: { xs: 'none', md: 'none' }}}/>
            <div className="row row-cols-2 row-cols-lg-1">
                <div className="col-md-6 col-12">
                  <TextField  name="UserName" className="form-control" label="UserName" variant="standard" defaultValue={row.original.UserName} slotProps={{ htmlInput: {readOnly: row.original.Id !== '' }}}/>              
                </div>
                <div className="col-md-6 col-12">
                  <TextField name="Password" className="form-control" label="Password" variant="standard" />
                </div>
            </div>

            <div className="row row-cols-lg-1">
              <div className="col-md-12 col-12">
                <TextField name="Email" label="Email" className="form-control" variant="standard" defaultValue={row.original.Email} />
              </div>
            </div>

            <div className="row row-cols-2 row-cols-lg-1">
              <div className="col-md-6 col-12">
                <TextField name="FirstName" label="First Name" className="form-control" variant="standard" defaultValue={row.original.FirstName} />
              </div>
              <div className="col-md-6 col-12">
                <TextField name="LastName" label="Last Name" className="form-control" variant="standard" defaultValue={row.original.LastName} />    
              </div>
            </div>
            
            <div className="row row-cols-2 row-cols-lg-1">
              <div className="col-md-6 col-12 mt-2">
                <FormControl className="w-100">
                  <InputLabel>Role</InputLabel>
                  {roleList && 
                    <Select name="RoleId" defaultValue={row.original.RoleId}>
                      {
                        roleList.map((d) => (
                        <MenuItem key={d.Id} value={d.value}>{d.text}</MenuItem>
                        ))
                      }
                    </Select>
                  }
                </FormControl>
              </div>
              <div className="col-md-6 col-12">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['DatePicker']}>
                    <DatePicker name="DOB" label="DOB" format="YYYY-MM-DD" defaultValue={row.original.DOB !== null && row.original.DOB !== '' ? dayjs(row.original.DOB) : undefined}/>
                  </DemoContainer>
                </LocalizationProvider>    
              </div>
            </div>
            
            <div className="row row-cols-2 row-cols-lg-1">
              <div className="col-md-6 col-6">
                <FormLabel id="demo-row-radio-buttons-group-label">Gender</FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue={row.original.Gender}
                    name="Gender"
                  >
                  <FormControlLabel value="F" control={<Radio />} label="Female" />
                  <FormControlLabel value="M" control={<Radio />} label="Male" />
                </RadioGroup>                
              </div>
              <div className="col-md-6 col-6">
                <InputLabel>Is Active</InputLabel>
                <FormControlLabel
                    control={<Checkbox name="IsActive" defaultChecked={row.original.IsActive}/>}
                    label=""
                  />
              </div>
            </div>
                        
          <div className="form-group g-3">
            <TextareaAutosize
              className="col-md-12 col-12"
              name="Notes"
              aria-label=""
              minRows={4}
              placeholder="Notes"
              defaultValue={row.original.Notes}
            />
          </div>

          <div className="form-group text-end">
            <Button className="col-lg-2 col-md-12 col-12"
              onClick={() => {
                table.setCreatingRow(null);                
                if (row.original.Id > 0){
                  table.setEditingRow(null);
                } 
              }}
            >
              Cancel
            </Button>
            <Button className="col-lg-2 col-md-12 col-12" type="submit" variant="contained" disabled={isCreatingUser || isUpdatingUser}>Save</Button>
          </div>
        </form>
      </Dialog>
    </>
  );
};

const MstUserComponent: React.FC<RequestMstUserComponentModel> = ({roleList, buList, gbpList, pageFunction}) => {  
  const [enableRefetch , setEnableRefetch] = useState(true);
  
  useEffect(() => {
    setEnableRefetch(false);
  },[enableRefetch]);

  return (
    <>        
      <DataTable enableRefetch={enableRefetch} buList={buList} gbpList={gbpList} roleList={roleList} pageFunction={pageFunction}/>
    </>
  );
};

export default MstUserComponent;